import { nu, type Digits } from './digits.ts';
import type { Locale } from '../locale.ts';

const cache = new Map<string, Intl.RelativeTimeFormat>();
function rtf(locale: Locale, digits: Digits) {
  const tag = `${locale === 'fa' ? 'fa-IR' : 'en-US'}-u-nu-${nu(digits)}`;
  let f = cache.get(tag);
  if (!f) cache.set(tag, (f = new Intl.RelativeTimeFormat(tag, { numeric: 'auto' })));
  return f;
}

/** "۳ روز دیگر" | "in 3 days"; "۱۲ دقیقه پیش" | "12 minutes ago" */
export function formatRelative(target: Date | string | number, locale: Locale, digits: Digits, now: number = Date.now()): string {
  const t = target instanceof Date ? target.getTime() : new Date(target).getTime();
  const diffS = Math.round((t - now) / 1000);
  const abs = Math.abs(diffS);
  const f = rtf(locale, digits);
  if (abs < 60) return f.format(diffS, 'second');
  if (abs < 3600) return f.format(Math.round(diffS / 60), 'minute');
  if (abs < 86_400) return f.format(Math.round(diffS / 3600), 'hour');
  if (abs < 86_400 * 30) return f.format(Math.round(diffS / 86_400), 'day');
  return f.format(Math.round(diffS / (86_400 * 30)), 'month');
}
